import Vue from 'vue'
import Router from 'vue-router'

Vue.use(Router)

// const originalPush = Router.prototype.push
// Router.prototype.push = function push(location, onResolve, onReject) {
//   if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
//   return originalPush.call(this, location).catch(err => err)
// }


/* Layout */
import Layout from '../views/layout/Layout'

/**
 * hidden: true                   if `hidden:true` will not show in the sidebar(default is false)
 * alwaysShow: true               if set true, will always show the root menu, whatever its child routes length
 *                                if not set alwaysShow, only more than one route under the children
 *                                it will becomes nested mode, otherwise not show the root menu
 * redirect: noredirect           if `redirect:noredirect` will no redirct in the breadcrumb
 * name:'router-name'             the name is used by <keep-alive> (must set!!!)
 * meta : {
	title: 'title'               the name show in submenu and breadcrumb (recommend set)
	icon: 'svg-name'             the icon show in the sidebar,
  }
 **/

export const constantRouterMap = [
	{ path: '/login', component: () => import('@/views/login/index'), hidden: true },
  { path: '/license', component: () => import('@/views/login/license'), hidden: true },
	{ path: '/404', component: () => import('@/views/404'), hidden: true },
	{
		path: '',
		component: Layout,
		redirect: '/home',
		children: [{
			path: 'home',
			name: 'home',
			component: () => import('@/views/home/index'),
			meta: { title: '首页', icon: 'home_def' }
		}]
	}
]

export const asyncRouterMap = [
	{
		path: '/parts',
		component: Layout,
		redirect: '/parts/partsCP',
		name: 'parts',
		meta: { title: '配件', icon: 'access_def' },
		children: [{
			path: 'partsCP',
			name: 'partsCP',
			component: () => import('@/views/parts/partsCP/index'),
			meta: { title: '配件', icon: 'access_def' }
		},
		{
			path: 'partsDetails',
			name: 'partsDetails',
			component: () => import('@/views/parts/partsCP/partsDetails'),
			hidden: true,
			meta: {
				title: '配件详情'
			}
		},
		{
			path: 'VINsearch',
			name: 'VINsearch',
			component: () => import('@/views/parts/partsCP/VINsearch'),
			hidden: true,
			meta: {
				title: 'VIN搜索结果'
			}
		},]
	},
	{
		path: '/shoppingCart',
		component: Layout,
		redirect: '/shoppingCart/cart',
		name: 'shoppingCart',
		meta: { title: '购物车', icon: 'shopp_def' },
		children: [{
			path: 'cart',
			name: 'cart',
			component: () => import('@/views/shoppingCart/component/index'),
			meta: {
				icon: 'shopp_def',
				title: '购物车'
			}
		},
		{
			path: 'count',
			name: 'count',
			component: () => import('@/views/shoppingCart/component/count'),
			hidden: true,
			meta: {
				title: '采购订单确认'
			}
		},
		{
			path: 'countSale',
			name: 'countSale',
			component: () => import('@/views/shoppingCart/component/countSale'),
			hidden: true,
			meta: {
				title: '销售订单确认'
			}
		},
		{
			path: 'lackGoods',
			name: 'lackGoods',
			component: () => import('@/views/shoppingCart/component/lackGoods'),
			hidden: true,
			meta: {
				title: '提交订单完成'
			}
		},
		{
			path: 'successGoods',
			name: 'successGoods',
			component: () => import('@/views/shoppingCart/component/successGoods'),
			hidden: true,
			meta: {
				title: '提交订单成功'
			}
		},
		{
			path: 'lackSuccessGoods',
			name: 'lackSuccessGoods',
			component: () => import('@/views/shoppingCart/component/lackSuccessGoods'),
			hidden: true,
			meta: {
				title: '提交订单完成'
			}
		},
		{
			path: 'manageAddress',
			name: 'manageAddress',
			component: () => import('@/views/shoppingCart/component/manageAddress'),
			hidden: true,
			meta: {
				title: '管理地址'
			}
		},
		]
	},
	{
		path: '/purchase',
		component: Layout,
		redirect: '/purchase/purchaseOrder',
		name: 'purchase',
		meta: { title: '采购订单', icon: 'procur_def' },
		children: [{
			path: 'purchaseOrder',
			name: 'purchaseOrder',
			component: () => import('@/views/purchase/purchaseOrder/index'),
			meta: { title: '采购订单', icon: 'procur_def' }
		},
		{
			path: 'purchaseDetails',
			name: 'purchaseDetails',
			component: () => import('@/views/purchase/purchaseOrder/purchaseDetails'),
			meta: { title: '采购订单详情' },
			hidden: true
		},
		{
			path: 'integralDetails',
			name: 'integralDetails',
			component: () => import('@/views/purchase/purchaseOrder/integralDetails'),
			meta: { title: '积分订单详情' },
			hidden: true
		}]
	},
	{
		path: '/sale',
		component: Layout,
		redirect: '/sale/saleOrder',
		name: 'sale',
		meta: { title: '销售订单', icon: 'sales_def' },
		children: [{
			path: 'saleOrder',
			name: 'saleOrder',
			component: () => import('@/views/sale/saleOrder/index'),
			meta: { title: '销售订单', icon: 'sales_def' }
		},
		{
			path: 'otherSale',
			name: 'otherSale',
			component: () => import('@/views/sale/saleOrder/otherSale'),
			meta: { title: '销售订单（开思网销订单）', icon: 'sales_def' },
			hidden: true
		},
		{
			path: 'otherDetail',
			name: 'otherDetail',
			component: () => import('@/views/sale/saleOrder/otherDetail'),
			meta: { title: '订单详情（开思网销订单）', icon: 'sales_def' },
			hidden: true
		},
		{
			path: 'saleDetails',
			name: 'saleDetails',
			component: () => import('@/views/sale/saleOrder/saleDetails'),
			meta: { title: '销售订单详情' },
			hidden: true
		}]
	},
	{
		path: '/integralShop',
		component: Layout,
		redirect: '/integralShop/integralShopCP',
		name: 'integralShop',
		meta: { title: '积分商城', icon: 'integral_def' },
		children: [{
			path: 'integralShopCP',
			name: 'integralShopCP',
			component: () => import('@/views/integralShop/integralShopCP/index'),
			meta: { title: '积分商城', icon: 'integral_def' }
		},
		{
			path: 'myPoints',
			name: 'myPoints',
			component: () => import('@/views/integralShop/integralShopCP/myPoints'),
			meta: { title: '我的积分' },
			hidden: true
		}]
	},
	{
		path: '/stockControl',
		component: Layout,
		name: 'stockControl',
		meta: { title: '库存管理', icon: 'inventory_def' },
		children: [{
			path: 'stock',
			name: 'stock',
			component: () => import('@/views/stockControl/stock/index'),
			meta: { title: '库存管理', icon: 'inventory_def' }
		}]
	},
	{
		path: '/customerManagement',
		component: Layout,
		name: 'customerManagement',
		meta: { title: '客户管理', icon: 'contact-fill' },
		children: [{
			path: 'customer',
			name: 'customer',
			component: () => import('@/views/customerManagement/customer/index'),
			meta: { title: '客户管理', icon: 'contact-fill' }
		}]
	},
	{
		path: '/returnGoods',
		component: Layout,
		redirect: '/returnGoods/returnCP',
		name: 'returnGoods',
		meta: { title: '退货管理', icon: 'return_def' },
		children: [{
			path: 'returnCP',
			name: 'returnCP',
			component: () => import('@/views/returnGoods/returnCP/index'),
			meta: { title: '退货管理', icon: 'return_def' }
		},
		{
			path: 'newPurchase',
			name: 'newPurchase',
			component: () => import('@/views/returnGoods/returnCP/newPurchase'),
			meta: { title: '新建采购退货单' },
			hidden: true
		},
		{
			path: 'newSale',
			name: 'newSale',
			component: () => import('@/views/returnGoods/returnCP/newSale'),
			meta: { title: '新建销售退货单' },
			hidden: true
		}]
	},
	{
		path: '/personalCenter',
		component: Layout,
		redirect: '/personalCenter/admin',
		name: 'personalCenter',
		meta: { title: '个人中心', icon: 'personal_def' },
		children: [{
			path: 'admin',
			name: 'admin',
			component: () => import('@/views/personalCenter/admin/index'),
			meta: { title: '个人中心', icon: 'personal_def' }
		},
		{
			path: 'index',
			name: 'index',
			component: () => import('@/views/personalCenter/admin/index'),
			meta: { title: '账户设置' },
			hidden: true
		},
		{
			path: 'editProfile',
			name: 'editProfile',
			component: () => import('@/views/personalCenter/admin/editProfile'),
			meta: { title: '编辑资料' },
			hidden: true
		},
		{
			path: 'purchaseChart',
			name: 'purchaseChart',
			component: () => import('@/views/personalCenter/admin/purchaseChart'),
			meta: { title: '采购统计分析' },
			hidden: true
		},
		{
			path: 'saleChart',
			name: 'saleChart',
			component: () => import('@/views/personalCenter/admin/saleChart'),
			meta: { title: '销售统计分析' },
			hidden: true
		},
		{
			path: 'sectorChart',
			name: 'sectorChart',
			component: () => import('@/views/personalCenter/admin/sectorChart'),
			meta: { title: '年度进货产品分类分析' },
			hidden: true
		},
		{
			path: 'posterBuilder',
			name: 'posterBuilder',
			component: () => import('@/views/personalCenter/admin/posterBuilder'),
			meta: { title: '海报生成器' },
			hidden: true
		},
		{
			path: 'posterEdit/:id',
			name: 'posterEdit',
			component: () => import('@/views/personalCenter/admin/posterEdit'),
			meta: { title: '海报编辑' },
			hidden: true
		},
		{
			path: 'eCard',
			name: 'eCard',
			component: () => import('@/views/personalCenter/admin/eCard'),
			meta: { title: '电子名片' },
			hidden: true,
		},
		{
			path: 'addOrEditECard',
			name: 'addOrEditECard',
			component: () => import('@/views/personalCenter/admin/addOrEditECard'),
			meta: { title: '生成电子名片' },
			hidden: true,
		}
		]
	},

	{ path: '*', redirect: '/404', hidden: true }
]

export default new Router({
	// mode: 'history', //后端支持可开
	scrollBehavior: () => ({
		y: 0
	}),
	routes: constantRouterMap
})



// WEBPACK FOOTER //
// ./src/router/index.js